import { combineEpics, Epic, ofType } from "redux-observable";
import { from, of } from "rxjs";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { ConversationService } from "../../services/ConversationService";
import { RootAction } from "../types";
import {
  GET_CONVERSATIONS,
  GetConversationsActionFailure,
  getConversationsActionFailure,
  GetConversationsActionSuccess,
  getConversationsActionSuccess,
} from "./actions";

export const conversationListEpic: Epic<
  RootAction,
  GetConversationsActionSuccess | GetConversationsActionFailure,
  any,
  any
> = (action$, state, any) =>
  action$.pipe(
    ofType(GET_CONVERSATIONS),
    switchMap((action) =>
      from(ConversationService.getConversations()).pipe(
        mergeMap((res) => {
          return [getConversationsActionSuccess(res)];
        }),
        catchError((error) =>
          of(error).pipe(mergeMap(() => [getConversationsActionFailure()]))
        )
      )
    )
  );

export const conversationEpic = combineEpics<any>(conversationListEpic);
